import { Link } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import "./AccessDenied.css";

export default function AccessDenied() {
  return (
    <div className="access-denied">
      <div className="access-card">
        <FaLock className="lock-icon" />

        <h1>Access Restricted</h1>

        <p>This feature is not available in your current subscription plan.</p>

        <p>Please upgrade your plan to unlock this feature.</p>

        <div className="buttons">
          <Link to="/dashboard" className="home-btn">
            Back to Dashboard
          </Link>

          {/* <Link to="/subscription" className="upgrade-btn">
            Upgrade Plan
          </Link> */}
          {/* <h1 className="upgrade-btn">Upgrade Plan</h1> */}
          <h1>Upgrade Plan</h1>
        </div>
      </div>
    </div>
  );
}
